











































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class CirclesPercentage extends Vue {
    @Prop({ required: true }) loading!: boolean

    chartOptions = {
        colors: ['#930D19'],
        chart: {
            height: '100%',
            width: '100%',
            type: 'radialBar',
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            radialBar: {
                startAngle: -135,
                endAngle: 225,
                hollow: {
                    margin: 0,
                    size: '70%',
                    background: '#fff',
                    image: undefined,
                    imageOffsetX: 0,
                    imageOffsetY: 0,
                    position: 'front',
                    dropShadow: {
                        enabled: true,
                        top: 3,
                        left: 0,
                        blur: 4,
                        opacity: 0.24
                    }
                },
                track: {
                    background: '#fff',
                    strokeWidth: '67%',
                    margin: 0, // margin is in pixels
                    dropShadow: {
                        enabled: true,
                        top: -3,
                        left: 0,
                        blur: 4,
                        opacity: 0.35
                    }
                },
                dataLabels: {
                    show: true,
                    name: {
                        offsetY: -10,
                        show: false,
                        color: '#888',
                        fontSize: '12px'
                    },
                    value: {
                        formatter: function (val: string) {
                            return `${val}%`
                        },
                        color: '#fff',
                        fontSize: '28px',
                        show: true
                    }
                }
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                type: 'horizontal',
                shadeIntensity: 1,
                gradientToColors: ['#BDBDBD'],
                inverseColors: true,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 60]
            }
        },
        stroke: {
            lineCap: 'round'
        },
        labels: ['']
    }

    series = [75]
}
